<se-combo-cell-editor-popup [width]="cellWidth"
                            [value]='value'
                            [dataSource]='dataSource'
                            [viewValueFieldName]='viewValueFieldName'
                            [valueFieldName]='valueFieldName'
                            [multi]="multi"
                            [isResettable]="isResettable"
                            [required]="required"
                            (selectionClosed)="_onSelectrionClosed()"
                            (formReady)="_onFormReady($event)"
                            (tabEvent)="tabPressed()"
                            >
</se-combo-cell-editor-popup>
